import { Typography, useTheme, Box, Grid, Stack } from '@mui/material';
import { Mail, MapPin, Phone } from 'react-feather';

// Components
import { IContributeDetailPeople } from 'src/utils/typings/response/contribute';
import { formatPhoneNumberBeforeSent, renderTextOrDefault } from 'src/utils/helpers/stringHelpers';
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';
import IconFeather from 'src/components/common/Icon';
import { isEmpty } from 'lodash';

const ContactPeople = ({ dataContribution }: { dataContribution: IContributeDetailPeople }) => {
  const theme = useTheme();

  return (
    <Grid container gap={1} wrap="nowrap">
      {getArrayDefault(
        dataContribution?.contribution_contact_people_profile?.map((item, index) => (
          <Grid key={`contribute-email-company-${index}`} item xs={12}>
            <Box
              width="100%"
              padding={2}
              border={`1px dashed ${theme.palette.divider}`}
              borderRadius={theme.shape.borderRadius / 2}
            >
              <Grid container rowGap={2}>
                {!isEmpty(item.email) && (
                  <Grid item xs={6}>
                    <Typography align="left" variant="caption2" color="text.secondary" component="p">
                      Email Address
                    </Typography>
                    <Box mt={1} />
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <IconFeather
                        icon={<Mail />}
                        muiProps={{
                          fontSize: 'small',
                          color: 'primary',
                        }}
                      />
                      <Typography align="left" variant="body2" color="text.primary" component="span">
                        {renderTextOrDefault(item.email)}
                      </Typography>
                    </Stack>
                  </Grid>
                )}
                {!isEmpty(item.phone_number) && (
                  <Grid item xs={6}>
                    <Typography align="left" variant="caption2" color="text.secondary" component="p">
                      Phone Number
                    </Typography>
                    <Box mt={1} />
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <IconFeather
                        icon={<Phone />}
                        muiProps={{
                          fontSize: 'small',
                          color: 'primary',
                        }}
                      />
                      <Typography align="left" variant="body2" color="text.primary" component="span">
                        {formatPhoneNumberBeforeSent(item.phone_code, item.phone_number)}
                      </Typography>
                    </Stack>
                  </Grid>
                )}
                {!isEmpty(item.address) && (
                  <Grid item xs={6}>
                    <Typography align="left" variant="caption2" color="text.secondary" component="p">
                      Address
                    </Typography>
                    <Box mt={1} />
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <IconFeather
                        icon={<MapPin />}
                        muiProps={{
                          fontSize: 'small',
                          color: 'primary',
                        }}
                      />
                      <Typography align="left" variant="body2" color="text.primary" component="span">
                        {renderTextOrDefault(item.address)}
                      </Typography>
                    </Stack>
                  </Grid>
                )}
              </Grid>
            </Box>
          </Grid>
        )),
      )}
    </Grid>
  );
};

export default ContactPeople;
